<lib-form-field-container
    [isOptional]="false"
    [hideErrors]="true"
    [kind]="FormContainerKind.SubForm">
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>

    <form [formGroup]="form">
        <lib-input-text
            class="w-100"
            [formControl]="form.controls.Format"
            [layout]="FormFieldLayout.Half"
            [isOptional]="false"
            [autocorrect]="false"
            (change)="InputChanged()">
            <ng-container label>
                <ng-content
                    label
                    select="[label]"></ng-content>
            </ng-container>

            <ng-container menu>
                <lib-menu-button
                    menu
                    [disabled]="isDisabled"
                    [kind]="ButtonKind.Link">
                    <ng-container
                        label
                        i18n="@@CommonInsert">
                        Insert
                    </ng-container>
                    <lib-menu-item
                        i18n-label="@@Common4DigitYear"
                        label="4 Digit Year"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.FourDigitYear)"></lib-menu-item>
                    <lib-menu-item
                        i18n-label="@@Common2DigitYear"
                        label="2 Digit Year"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.TwoDigitYear)"></lib-menu-item>
                    <lib-menu-item
                        i18n-label="@@Common2DigitMonth"
                        label="2 Digit Month"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.TwoDigitMonth)"></lib-menu-item>
                    <lib-menu-item
                        i18n-label="@@Common2DigitSequenceNumber"
                        label="2 Digit Sequence Number"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.TwoDigitSequenceNumber)"></lib-menu-item>
                    <lib-menu-item
                        i18n-label="@@Common4DigitSequenceNumber"
                        label="4 Digit Sequence Number"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.FourDigitSequenceNumber)"></lib-menu-item>
                    <lib-menu-item
                        i18n-label="@@Common6DigitSequenceNumber"
                        label="6 Digit Sequence Number"
                        [stopPropagation]="true"
                        (clicked)="AddPlaceholder(InvoiceNumbersFormat.SixDigitSequenceNumber)"></lib-menu-item>
                </lib-menu-button>
            </ng-container>
        </lib-input-text>
        <!-- value changed should never be used - only for mark as dirty -->
        <lib-input-number
            [formControl]="form.controls.NextNumber"
            [isOptional]="false"
            [layout]="FormFieldLayout.Half"
            (change)="InputChanged()">
            <ng-container
                label
                i18n="@@CommonNextInvoiceNumberLabel">
                Next Invoice Number
            </ng-container>
        </lib-input-number>
    </form>
    <div class="d-flex gap-space-8 padding-top-16">
        <p
            class="typography-body-medium-strong"
            i18n="@@CommonPreviewWithColon">
            Preview:
        </p>
        @if (!form.controls.Format.value) {
            <p
                class="typography-body-medium base-100"
                i18n="@@CommonNotSpecifiedLabel">
                Not specified
            </p>
        }
        <p class="typography-body-medium">{{ previewText }}</p>
    </div>
</lib-form-field-container>
